export const coupon = {
    coupon: 'Coupons',
    advanceFilter: 'Advance Filter',
    search: 'Search',
    couponCondition: 'Coupon Condition',
    name: 'Name',
    amount: 'Amount',
    maxAmount: 'Maximum Amount',
    type: 'Type',
    source: 'Source',
    turnover: 'Turnover',
    turnoverSetting: 'Turnover Setting',
    createdAt: 'Created At',
    expiredAt: 'Expired At',
    add: 'Add',
    createCouponCondition: 'Create Coupon Condition',
    cancel: 'Cancel',
    isActive: 'Active',
    campaign: 'Campaign',
    generate: 'Generate Code',
    update: 'Update',
    viewCoupon: 'View Coupon',
    code: 'Code',
    used: 'Available',
    userId: 'User Id',
    updateCouponCondition: 'Update Coupon Condition',
    length: 'Length of Character Coupon Code',
    description: 'Description',
    bonusAmount: 'Bonus Amount (in cent or percentage)',
    bonusCap: 'Bonus Cap (in cent)',
    turnoverValue: 'Turnover Value (in cent or percentage)',
    bonusType: 'Bonus Type',
    depositType: 'Deposit Type',
    depositMinimum: 'Deposit Minimum',
    limitUsePerUser: 'Limit Use Per User',
    limitUsePerUserPerDay: 'Limit Use Per User Per Day',
    limitUsePerCampaign: 'Limit Use Per Campaign',
    newUserDuration: 'New User Duration (Hour)',
    couponAmount: 'Coupon Amount',
    couponMode: 'Coupon Mode',
    generic: 'Generic',
    unique: 'Unique',
    expireHour: 'Coupon expires in hours (0 = no expiry)',
    // ... existing translations
    
    // Bonus Type Options
    fix_amount: 'Fix Amount',
    fixed_amount: 'Fix Amount',
    deposit_percent: 'Deposit Percent',
    valid_balance_percent: 'Valid Balance Percentage',
    
    // Deposit Type Options
    none: 'None',
    single_time_latest: 'Latest (Single time used)',
    multiple_time_latest: 'Latest (Multiple times used)',
    cumulative: 'Cumulative',
    
    // Turnover Options
    bonus_percent: 'Bonus Percent',

    // Period Deposit Type
    period: 'Period',
    depositPeriodStart: 'Deposit Period Start',
    depositPeriodEnd: 'Deposit Period End',

    // Schedule
    hasSchedule: 'Has Schedule',
    scheduleStartDate: 'Schedule Start Date',
    scheduleEndDate: 'Schedule End Date',
    scheduleAllDay: 'All Day',
    scheduleStartTime: 'Schedule Start Time',
    scheduleEndTime: 'Schedule End Time',
    scheduleRepeatEvery: 'Repeat Every',
    scheduleDaysOfWeek: 'Days of Week',
    repeatUnit_none: 'None',
    repeatUnit_day: 'Day',
    repeatUnit_week: 'Week',
    repeatUnit_month: 'Month',
    day_sun: 'S',
    day_mon: 'M',
    day_tue: 'T',
    day_wed: 'W',
    day_thu: 'T',
    day_fri: 'F',
    day_sat: 'S',
    scheduleEndDateError: 'End date must be at least 1 month after start date',
}